import { useCallback, useEffect, useState } from 'react';

const THEME_KEY = 'zeevogo-theme';

function readInitialTheme() {
  try {
    const saved = localStorage.getItem(THEME_KEY);
    if (saved === 'dark' || saved === 'light') return saved;
  } catch (e) {
    // localStorage unavailable - fall back to light
  }
  return 'light';
}

export function useTheme() {
  const [theme, setTheme] = useState(readInitialTheme);

  useEffect(() => {
    document.documentElement.setAttribute('data-theme', theme);
    // Tailwind's `darkMode: 'class'` strategy (which shadcn/ui's own CSS
    // variables key off) only reacts to a `dark` class, not data-theme -
    // keep both in sync or Card/Button/etc. get stuck on light values.
    document.documentElement.classList.toggle('dark', theme === 'dark');
  }, [theme]);

  const toggleTheme = useCallback(() => {
    setTheme((prev) => {
      const next = prev === 'dark' ? 'light' : 'dark';
      try {
        localStorage.setItem(THEME_KEY, next);
      } catch (e) {
        // localStorage unavailable - theme just won't persist
      }
      return next;
    });
  }, []);

  return { theme, toggleTheme };
}
